import isNil from 'lodash-es/isNil';
import unescape from 'lodash-es/unescape';
import { useMembershipAccountQuery } from '@modules/Dashboard/hooks/useMembershipAccountQuery';
import { getMapFromTierIds } from '@utils/tiers';
import { getListingTypeUtil, getOfferTypeUtil } from '../Product.utils';
import { useOfferQuery } from './useOfferQuery';
export const useOffer = (productId) => {
    const { offerQuery, invalidateOfferQuery, setOfferData } = useOfferQuery([productId]);
    const { membershipAccountQuery } = useMembershipAccountQuery();
    const manufacturingService = offerQuery.data?.manufacturingService || 'FOURTHWALL_BESPOKE';
    const offerType = getOfferTypeUtil(manufacturingService);
    const listingType = getListingTypeUtil(offerQuery.data);
    const getOfferFromOfferData = (offerData = offerQuery.data) => {
        return {
            id: offerData?.id,
            bespokeProductId: offerData?.bespokeProductId,
            name: unescape(offerData?.name || ''),
            categoryId: offerData?.categoryId || '',
            slug: offerData?.slug || '',
            productId: offerData?.productId,
            images: offerData?.images || [],
            variantTypes: offerData?.variantTypes || [],
            visualHints: offerQuery.data?.visualHints || { customSkus: false },
            description: unescape(offerData?.description || ''),
            variants: offerData?.variants || [],
            digitalItems: offerData?.digitalItems || [],
            fulfillmentService: offerData?.fulfillingService || 'FULFILLED_BY_CREATOR',
            manufacturingService,
            offerType,
            listingType,
            shipment: offerData?.shipment,
            state: offerData?.state,
            customizationId: offerData?.customizationId,
            memberships: {
                tiers: membershipAccountQuery.data?.tiers,
                hasAllowedTiers: !isNil(offerData?.requirements?.allowedTiers),
                allowedTiersType: offerData?.requirements?.allowedTiers?.type || 'ALL_TIERS',
                tiersIds: getMapFromTierIds(offerData?.requirements?.allowedTiers?.type === 'SELECTED_TIERS'
                    ? offerData.requirements?.allowedTiers.tiersIds
                    : [], membershipAccountQuery.data?.tiers),
            },
            soundScanInfo: offerData?.soundScanInfo,
            requirePhoneNumberFromBuyer: offerData?.requirePhoneNumberFromBuyer,
            customsInformation: offerData?.customsInformation || {},
            config: offerData?.config,
            isSettingCostsRequired: offerData?.isSettingCostsRequired,
            metafields: offerData?.metafields,
            parentOffer: offerData?.parentOffer,
        };
    };
    return {
        offer: getOfferFromOfferData(),
        isSuccess: offerQuery.isSuccess,
        isLoading: offerQuery.isLoading,
        isError: offerQuery.isError,
        setOfferData,
        getOfferFromOfferData,
        invalidateOffer: invalidateOfferQuery,
    };
};
